// target is a DOM element (anything under .nav-item)
// clazz: online, paper, arena
function updateDropdownTypeToggle(target, clazz, clazzLabelText) {
  var navItem = target.closest(".nav-item");
  if (!navItem) return;
  navItem.querySelectorAll(".nav-link").forEach(function(el) {
    el.textContent = clazzLabelText;
    el.classList.remove("paper", "arena", "online");
    el.classList.add(clazz);
  });
}
window.updateDropdownTypeToggle = updateDropdownTypeToggle;

window.MTGGoldfishDygraph = window.MTGGoldfishDygraph || {};
window.MTGGoldfishDygraph.dygraphReady = !!window.Dygraph;
window.MTGGoldfishDygraph.dygraphReadyCallbacks = window.MTGGoldfishDygraph.dygraphReadyCallbacks || [];

window.MTGGoldfishDygraph.notifyDygraphLoadTimeout = function(queueLength) {
  var error = new Error("Dygraph did not load before price chart initialization timed out");
  if (window.Bugsnag && typeof window.Bugsnag.notify === "function") {
    window.Bugsnag.notify(error, function(event) {
      event.severity = "warning";
      if (typeof event.addMetadata === "function") {
        event.addMetadata("dygraph", {
          queueLength: queueLength,
          timeoutMs: 5000,
          path: window.location && window.location.pathname
        });
      }
    });
  } else if (window.console && typeof window.console.warn === "function") {
    window.console.warn(error);
  }
};

window.MTGGoldfishDygraph.flushDygraphReady = function() {
  window.MTGGoldfishDygraph.dygraphReady = true;
  if (window.MTGGoldfishDygraph.dygraphReadyTimeoutId) {
    clearTimeout(window.MTGGoldfishDygraph.dygraphReadyTimeoutId);
    window.MTGGoldfishDygraph.dygraphReadyTimeoutId = null;
  }

  var callbacks = window.MTGGoldfishDygraph.dygraphReadyCallbacks || [];
  window.MTGGoldfishDygraph.dygraphReadyCallbacks = [];
  callbacks.forEach(function(callback) {
    callback();
  });
};

window.MTGGoldfishDygraph.whenDygraphReady = function(callback) {
  if (window.Dygraph) {
    window.MTGGoldfishDygraph.dygraphReady = true;
    callback();
    return;
  }

  window.MTGGoldfishDygraph.dygraphReadyCallbacks.push(callback);
  if (!window.MTGGoldfishDygraph.dygraphReadyTimeoutId) {
    window.MTGGoldfishDygraph.dygraphReadyTimeoutId = setTimeout(function() {
      var queueLength = window.MTGGoldfishDygraph.dygraphReadyCallbacks.length;
      window.MTGGoldfishDygraph.dygraphReadyCallbacks.forEach(function(queuedCallback) {
        if (typeof queuedCallback.dygraphReadyTimeout === "function") {
          queuedCallback.dygraphReadyTimeout();
        }
      });
      window.MTGGoldfishDygraph.notifyDygraphLoadTimeout(queueLength);
      window.MTGGoldfishDygraph.dygraphReadyCallbacks = [];
      window.MTGGoldfishDygraph.dygraphReadyTimeoutId = null;
    }, 5000);
  }
};
